import React from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { PRODUCTS } from 'constants/app-paths'
import { ErrorCard } from 'ui-components/ErrorCard'
import { Button } from 'ui-components/Button'

export default function ErroMessage({ errorMessage }) {
  const history = useHistory()

  return (
    <ErrorCard
      title="Houve um erro ao buscar o produto"
      message={errorMessage}
    >
      <p>
        Volte para a lista de produtos e tente novamente
      </p>
      <p>
        <Button onClick={() => history.push(PRODUCTS)}>
          Lista de produtos
        </Button>
      </p>
    </ErrorCard>
  )
}

ErroMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
}
